<template>
    <div class="animated fadeIn vld-parent custom-100">
        <b-row class="custom-flex-1">
            <b-col sm="12">
                <auftraegeTable ref="auftraegeTable" :table-data="data" :show-icon="false"></auftraegeTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import auftraegeTable from './AuftragTable'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

    export default {
        name: "Auftraege_Freigabe_Offen",
        components: {'auftraegeTable': auftraegeTable},
        data() {
            return {
                loader: undefined,
                data: [],
                currentPage: 1
            }
        },
        created() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/auftragsbuch/data/freigabe/offen'
            ).then(this.responseOkFetch, this.responseError)
        },
        methods: {

            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkFetch(response) {
                this.hideLoader();
                this.$refs.auftraegeTable.currentPage = 1;
                if (response.status === 200 && response.body.status === "ok") {
                    this.data = response.body.data;
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            }
        },
    }
</script>

<style scoped>

</style>
